import { render } from "./VisionThreeFilters.vue?vue&type=template&id=ba5e852c"
import script from "./VisionThreeFilters.vue?vue&type=script&lang=js"
export * from "./VisionThreeFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__